import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Topbar } from '../topbar/topbar';
import { Sidebar } from '../sidebar/sidebar';

@Component({
  selector: 'app-layout',
  imports: [RouterModule, Topbar, Sidebar],
  templateUrl: './layout.html',
  styleUrl: './layout.scss',
})
export class Layout {
  protected sidebarCollapsed = false;

  protected toggleSidebar(): void {
    this.sidebarCollapsed = !this.sidebarCollapsed;
    setTimeout(() => globalThis.dispatchEvent(new Event('resize')));
  }
}
